import { useEffect } from 'react';
import { Text, View } from 'react-native';
import Animated, {
  useSharedValue,
  withRepeat,
  withTiming,
  useAnimatedStyle,
  Easing,
} from 'react-native-reanimated';
import { Cat } from 'lucide-react-native';

import { CatFishPattern } from '@/components/ui';
import { colors, typography } from '@/theme/tokens';

export function SplashScreen() {
  const scale = useSharedValue(0.92);

  useEffect(() => {
    scale.value = withRepeat(
      withTiming(1.06, { duration: 800, easing: Easing.inOut(Easing.quad) }),
      -1,
      true,
    );
  }, [scale]);

  const orbStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.magenta[800],
        overflow: 'hidden',
        // @ts-ignore web only
        backgroundImage: `linear-gradient(135deg, ${colors.magenta[800]} 0%, ${colors.magenta[700]} 60%, ${colors.magenta[500]} 100%)`,
      }}
    >
      <CatFishPattern variant="magenta" opacity={0.45} tileSize={360} />
      <Animated.View
        style={[
          {
            width: 88,
            height: 88,
            borderRadius: 44,
            backgroundColor: 'rgba(255,255,255,0.18)',
            marginBottom: 18,
            alignItems: 'center',
            justifyContent: 'center',
          },
          orbStyle,
        ]}
      >
        <Cat size={42} color={colors.white} />
      </Animated.View>
      <Text
        style={{
          color: colors.white,
          fontFamily: typography.display.fontFamily,
          fontSize: 32,
          fontWeight: typography.weights.bold,
          letterSpacing: -0.4,
        }}
      >
        CliniCAT
      </Text>
      <Text style={{ color: 'rgba(255,255,255,0.7)', marginTop: 6, letterSpacing: 1 }}>
        Cargando tu clínica…
      </Text>
    </View>
  );
}
